<ui-tab-group class="hidden md:block">
  <a
    routerLink="./general"
    routerLinkActive
    #general="routerLinkActive"
    [attr.aria-current]="general.isActive"
  >
    <ui-tab [active]="general.isActive">
      <h2 class="flex">
        <ng-icon name="heroInformationCircle" size="20" class="!block mr-2" />
        {{ 'cockpit.energyInterfaces.details.nav.general' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./consumption"
    routerLinkActive
    #consumption="routerLinkActive"
    [attr.aria-current]="consumption.isActive"
  >
    <ui-tab [active]="consumption.isActive">
      <h2 class="flex">
        <ng-icon name="heroChartPie" size="20" class="!block mr-2" />
        {{ 'cockpit.energyInterfaces.details.nav.consumption' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./address"
    routerLinkActive
    #address="routerLinkActive"
    [attr.aria-current]="address.isActive"
    *hasRole="'USER_ADMIN'"
  >
    <ui-tab [active]="address.isActive">
      <h2 class="flex text-admin dark:text-admin-darkmode">
        <ng-icon name="heroMapPin" size="20" class="!block mr-2" />
        {{ 'cockpit.energyInterfaces.details.nav.address' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./load-curve"
    routerLinkActive
    #loadCurve="routerLinkActive"
    [attr.aria-current]="loadCurve.isActive"
    *hasRole="'USER_ADMIN'"
  >
    <ui-tab [active]="loadCurve.isActive">
      <h2 class="flex text-admin dark:text-admin-darkmode">
        <ng-icon name="heroPresentationChartLine" size="20" class="!block mr-2" />
        {{ 'cockpit.energyInterfaces.details.nav.loadCurve' | transloco }}
      </h2>
    </ui-tab>
  </a>
</ui-tab-group>
<div class="md:hidden">
  <ui-select (selectChange)="onSelectChange($event)">
    <option
      routerLink="./general"
      value="./general"
      routerLinkActive
      #generalMobile="routerLinkActive"
      [selected]="generalMobile.isActive"
    >
      {{ 'cockpit.energyInterfaces.details.nav.general' | transloco }}
    </option>
    <option
      routerLink="./consumption"
      value="./consumption"
      routerLinkActive
      #consumptionMobile="routerLinkActive"
      [selected]="consumptionMobile.isActive"
    >
      {{ 'cockpit.energyInterfaces.details.nav.consumption' | transloco }}
    </option>
    <option
      routerLink="./address"
      value="./address"
      routerLinkActive
      #addressMobile="routerLinkActive"
      [selected]="addressMobile.isActive"
      *hasRole="'USER_ADMIN'"
    >
      {{ 'cockpit.energyInterfaces.details.nav.address' | transloco }}
    </option>
    <option
      routerLink="./load-curve"
      value="./load-curve"
      routerLinkActive
      #loadCurveMobile="routerLinkActive"
      [selected]="loadCurveMobile.isActive"
      *hasRole="'USER_ADMIN'"
    >
      {{ 'cockpit.energyInterfaces.details.nav.loadCurve' | transloco }}
    </option>
  </ui-select>
</div>
